import { defineComponent } from 'vue';
export default defineComponent({
    name: 'stock-item',
    props: {
        item: {
            type: Object,
            default: ({}),
        },
    },
});
